//components
import { KickerDot } from '../SectionHeading';
import { CountUp } from '../CountUp';

//styles
import {
  ProofSection,
  BigNums,
  BigNum,
  BigNumValue,
  BigNumLabel,
  SectionTitleCustom,
  KickerCustom,
} from './Proof.styles';

import { Container } from '@/components/Grid';

export const proofOutcomes = [
  { value: 83, suffix: '%', label: 'lower cost per task' },
  { value: 80, suffix: '%', label: 'faster completion time' },
  { value: 100, suffix: 's of hrs', label: 'saved per week' },
];

export function Proof({ outcomes }) {
  return (
    <ProofSection id="proof">
      <Container>
        <KickerCustom>
          <KickerDot />
          Outcomes
        </KickerCustom>
        <SectionTitleCustom>What Loadsmart AI gives back.</SectionTitleCustom>

        <BigNums>
          {outcomes.map((outcome) => (
            <BigNum key={outcome.label}>
              <BigNumValue>
                {outcome.prefix}
                <CountUp value={outcome.value} />
                {outcome.suffix}
              </BigNumValue>
              <BigNumLabel>{outcome.label}</BigNumLabel>
            </BigNum>
          ))}
        </BigNums>
      </Container>
    </ProofSection>
  );
}
